import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse, BusinessUnit, CloneProdDto, CloneProdJob } from '@/types';

export const cloneProdService = {
  async start(accountId: number, payload: CloneProdDto) {
    const res = await api.post<ApiResponse<{ job: CloneProdJob; businessUnit: BusinessUnit }>>(
      API_ENDPOINTS.CLONE_PROD.START(accountId),
      payload
    );
    return res.data.data;
  },

  async job(accountId: number, jobId: string): Promise<CloneProdJob> {
    const res = await api.get<ApiResponse<{ job: CloneProdJob }>>(
      API_ENDPOINTS.CLONE_PROD.JOB(accountId, jobId)
    );
    return res.data.data.job;
  }
};
